import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUserState {
  userId: number | null;
}

const initialState: IUserState = {
  userId: null,
};

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    setUserId: (state, action: PayloadAction<number | null>) => {
      state.userId = action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUserId },
} = userSlice;
